<template>
    <ais-instant-search class="product-search" :class="{ 'product-search--sidebar': sidebar }" :search-client="searchClient" index-name="batteries" :routing="routing">
        <ais-configure :hits-per-page.camel="30" />

        <div v-if="sidebar" class="product-search__overlay" @click="sidebar = false"></div>
        <Sidebar v-show="sidebar" :active.sync="sidebar" />

        <section ref="main" class="product-search__main">
            <div class="product-search__toolbar">
                <button class="iconlink" @click="sidebar = !sidebar">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="30">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>

                <ais-stats>
                    <template v-slot="{ hitsPerPage, nbHits, page }">
                        <span>{{ nbHits }} Results</span> <span>Showing {{ page * hitsPerPage + 1 }} - {{ page * hitsPerPage + hitsPerPage }}</span>
                    </template>
                </ais-stats>

                <ais-search-box placeholder="Search" />
            </div>

            <ais-hits v-slot="{ items }">
                <ProductTable :products="items" />
            </ais-hits>

            <ais-pagination
                :show-first="false"
                :show-last="false"
                :padding="1"
                @page-change="scrollTop"
            />
        </section>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import Sidebar from './Sidebar.vue';
import ProductTable from './Table.vue';

export default {
    components: {
        Sidebar,
        ProductTable
    },

    data() {
        return {
            searchClient: algoliasearch(
                window.algoliaId,
                window.algoliaSearchKey
            ),
            routing: {
                router: historyRouter(),
                stateMapping: singleIndexMapping('storage'),
            },
            sidebar: false
        };
    },

    watch: {
        sidebar(value) {
            if (value) {
                document.documentElement.classList.add('scroll-lock-mobile');
            } else {
                document.documentElement.classList.remove('scroll-lock-mobile');
            }
        }
    },

    mounted() {
        const isDesktop = window.matchMedia('(min-width: 1024px)');
        this.sidebar = isDesktop.matches;
    },

    methods: {
        scrollTop() {
            this.$scrollTo(this.$refs.main);
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep {
    .ais-Pagination {
        margin: 0 28px;
    }

    .ais-Pagination-list {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 55px 0;
        font-size: 14px;
    }

    .ais-Pagination-item {
        margin: 0 0.5em;
    }

    .ais-Pagination-link {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        color: #414042;
        background-color: #ffffff;
        border: 1px solid #ffffff;
        outline: none;
        cursor: pointer;
        z-index: 0;
        font-weight: 500;
    }

    .ais-Pagination-item--previousPage,
    .ais-Pagination-item--nextPage {
        .ais-Pagination-link {
            font-size: 30px;
            color: #ffffff;
            background-color: #ef6e0b;
            border: 1px solid #ef6e0b;
        }
    }

    .ais-Pagination-item--previousPage {
        margin-right: auto;
    }

    .ais-Pagination-item--nextPage {
        margin-left: auto;
    }

    .ais-Pagination-item--selected {
        .ais-Pagination-link {
            border: 1px solid #ef6e0b;
            color: #ef6e0b;
        }
    }

    .ais-Pagination-item--disabled {
        .ais-Pagination-link {
            color: #afafaf;
            border: 1px solid #afafaf;
            background-color: #ffffff;
        }
    }
}
</style>
